import { Matiere, COEF_OPTION1, COEF_OPTION2 } from '../types/main';

// épreuves anticipées
export const COEF_FRANCAIS_ECRIT = 2;
export const COEF_FRANCAIS_ORAL = 2;
export const COEF_TPE = 2;

// contrôle continu
export const COEF_MATHS = 7;
export const COEF_MATHS_SISPE = 9;
export const COEF_PC = 6;
export const COEF_PC_SISPE = 8;
export const COEF_SVT = 6;
export const COEF_SVT_SISPE = 8;
export const COEF_EAT = 7; // éco agro territoires
export const COEF_EAT_SISPE = 9;
export const COEF_SI = 6;
export const COEF_SI_SI_0_SPE = 8;
export const COEF_ISN_SPE = 2;

export const COEF_HG = 3;
export const COEF_LV1 = 3;
export const COEF_LV2 = 2;
export const COEF_PHILO = 3;
export const COEF_EPS = 2;

export const COEF_EPS_COMP = 2;


export const matieres_EA_S = [
  {
    name: 'francais_ecrit',
    label: 'Français Ecrit',
    coef: COEF_FRANCAIS_ECRIT,
  },
  {
    name: 'francais_oral',
    label: 'Français Oral',
    coef: COEF_FRANCAIS_ORAL,
  },
  {
    name: 'TPE',
    label: 'TPE',
    coef: COEF_TPE,
    pointsAuDessus10: true,
  },
] as Matiere[];

export const matieres_S = [
  {
    name: 'maths',
    label: 'Mathématiques',
    coef: COEF_MATHS,
  },
  {
    name: 'PC',
    label: 'Physique Chimie',
    coef: COEF_PC,
  },
  {
    name: 'SVT',
    label: 'SVT',
    coef: COEF_SVT,
  },
  {
    name: 'EAT',
    label: 'Écologie, agronomie et territoires',
    coef: COEF_EAT,
  },
  {
    name: 'SI',
    label: 'Sciences de l\'ingénieur',
    coef: COEF_SI,
  },
  {
    name: 'ISN',
    label: 'Informatique et sciences du numérique',
    coef: COEF_ISN_SPE,
  },
  {
    name: 'hist_geo',
    label: 'Histoire - Géographie',
    coef: COEF_HG,
  },
  {
    name: 'LV1',
    label: 'LV1',
    coef: COEF_LV1,
  },
  {
    name: 'LV2',
    label: 'LV2',
    coef: COEF_LV2,
  },
  {
    name: 'philo',
    label: 'Philosophie',
    coef: COEF_PHILO,
  },
  {
    name: 'EPS',
    label: 'EPS',
    coef: COEF_EPS,
  },
  {
    name: 'EPS_comp',
    label: 'EPS de complément',
    coef: COEF_EPS_COMP,
  },
] as Matiere[];
